<template lang="pug">
  .form
    .form__elem.form__elem_short
      .form-elem.form-elem_horizontal
        .form-elem__title Документ, удостоверяющий личность
        .form-elem__body
          select.select.select_full(
            v-model="localChildDocType"
            @change="onChangeType($event)"
          )
            option(:value="true") Свидетельство о рождении
            option(:value="false") Паспорт
    //- //Элементы формы при выбранном свидетельстве о рождении
    .form__elem(
      v-show="childDocType"
    )
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : requireErrors.birth_certificate }"
      )
        .form-elem__title Серия и номер
        .form-elem__body
          input.input.input_full(
            v-model="localBirthCertificate"
            v-on:keyup="keymonitor"
            maxlength="16"
          )
    .form__elem.form__elem_full(
      v-show="childDocType"
    )
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : requireErrors.birth_certificate_attachments }"
      )
        .form-elem__title Копия свидетельства о рождении
        .form-elem__body
          attach-file(
            :attachments="localBirthCertificateAttachments"
            attachment-type="child_passport"
            fieldname="birth_certificate_attachments"
            @onChangeAttachments="changeAttachments"
            :keymonitor="keymonitor"
          )
    //- //Элементы формы при выбранном паспорте
    .form__elem(
      v-show="!childDocType"
    )
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : requireErrors.passport }"
      )
        .form-elem__title Серия и номер
        .form-elem__body
          input.input.input_full(
            v-model="localPassport"
            v-on:keyup="keymonitor"
            v-mask="'## ## ######'"
          )
    .form__elem.form__elem_short(
      v-show="!childDocType"
    )
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : requireErrors.passport_issue_date }"
      )
        .form-elem__title Дата выдачи
        .form-elem__body
          date-picker(
            placeholder="дд.мм.гггг"
            v-model="localPassportIssueDate"
            format="DD.MM.YYYY"
            lang="ru"
            input-class="input input_full"
            @change="onChangeDate($event)"
            :clearable="false"
            :editable="true"
            :not-after="new Date()"
          )
    .form__elem.form__elem_full(
      v-show="!childDocType"
    )
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : requireErrors.passport_attachments }"
      )
        .form-elem__title Копия паспорта
        .form-elem__body
          attach-file(
            :attachments="localPassportAttachments"
            attachment-type="passport"
            fieldname="passport_attachments"
            @onChangeAttachments="changeAttachments"
            :keymonitor="keymonitor"
          )
        .form-elem__description

    .form__elem(
      v-show="!childDocType"
    )
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : requireErrors.inn }"
      )
        .form-elem__title ИНН
        .form-elem__body
          input.input.input_full(
            v-model="localInn"
            v-on:keyup="keymonitor"
            placeholder="Номер"
            v-mask="'############'"
          )
    .form__elem.form__elem_full(
      v-show="!childDocType"
    )
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : requireErrors.inn_attachments }"
      )
        .form-elem__title Копия ИНН
        .form-elem__body
          attach-file(
            :attachments="localInnAttachments"
            attachment-type="inn"
            fieldname="inn_attachments"
            @onChangeAttachments="changeAttachments"
            :keymonitor="keymonitor"
          )
    .form__elem
      .form-elem.form-elem_horizontal(
      :class="{ 'form-elem_error' : requireErrors.snils }"
      )
        .form-elem__title СНИЛС
        .form-elem__body
          input.input.input_full(
          v-model="localSnils"
          v-on:keyup="keymonitor"
          placeholder="Номер"
          v-mask="'###-###-###-##'"
          )
    .form__elem.form__elem_full
      .form-elem.form-elem_horizontal(
      :class="{ 'form-elem_error' : requireErrors.snils_attachments }"
      )
        .form-elem__title Копия СНИЛС
        .form-elem__body
          attach-file(
          :attachments="localSnilsAttachments"
          attachment-type="snils"
          fieldname="snils_attachments"
          @onChangeAttachments="changeAttachments"
          :keymonitor="keymonitor"
          )
</template>

<script>
import AttachFile from "@/components/attach-file/AttachFile";
import DatePicker from "vue2-datepicker";

export default {
  name: "FormChildDocs",
  components: {
    AttachFile,
    DatePicker
  },
  props: {
    childDocType: {
      type: Boolean,
      default: true
    },
    birthCertificate: {
      type: String,
      default: ""
    },
    birthCertificateAttachments: {
      type: Array,
      default: () => []
    },
    passport: {
      type: String,
      default: ""
    },
    passportIssueDate: {
      type: [String, Object],
      default: ""
    },
    passportAttachments: {
      type: Array,
      default: () => []
    },
    snils: {
      type: String,
      default: ""
    },
    snilsAttachments: {
      type: Array,
      default: () => []
    },
    inn: {
      type: String,
      default: ""
    },
    innAttachments: {
      type: Array,
      default: () => []
    },
    requireErrors: {
      type: Object,
      default: () => ({})
    },
    keymonitor: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  computed: {
    localChildDocType: {
      get() {
        return this.childDocType;
      },
      set(value) {
        this.$emit("onChangeDocType", [value, "childDocType"]);
      }
    },
    localBirthCertificate: {
      get() {
        return this.birthCertificate;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "birth_certificate"]);
      }
    },
    localBirthCertificateAttachments: {
      get() {
        return this.birthCertificateAttachments;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "birth_certificate_attachments"]);
      }
    },
    localPassport: {
      get() {
        return this.passport;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "passport"]);
      }
    },
    localPassportIssueDate: {
      get() {
        if (!this.passportIssueDate) {
          return "";
        }
        return this.passportIssueDate;
      },
      set() {}
    },
    localPassportAttachments: {
      get() {
        return this.passportAttachments;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "passport_attachments"]);
      }
    },
    localSnils: {
      get() {
        return this.snils;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "snils"]);
      }
    },
    localSnilsAttachments: {
      get() {
        return this.snilsAttachments;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "snils_attachments"]);
      }
    },
    localInn: {
      get() {
        return this.inn;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "inn"]);
      }
    },
    localInnAttachments: {
      get() {
        return this.innAttachments;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "inn_attachments"]);
      }
    }
  },
  methods: {
    onChangeType(e) {
      this.$emit("onChangeDocType", [
        e.target.value === "true",
        "childDocType"
      ]);
    },
    onChangeDate(date) {
      const d = new Date(date);
      const _date = `${d.getFullYear()}-${("0" + (d.getMonth() + 1)).slice(
        -2
      )}-${("0" + d.getDate()).slice(-2)}`;
      this.$emit("onChangeValue", [_date, "passport_issue_date"]);
    },
    changeAttachments(data) {
      this.$emit("onChangeValue", [data.value, data.fieldname]);
      this.keymonitor();
    }
  }
};
</script>
